module.exports = __webpack_public_path__ + "img/site-brand.323b4352.svg";